import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

const Activities = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Activities component');
    }

    const [activitiesData, setActivitiesData] = useState([]);

    useEffect(() => {
        fetch('/data/activities.json')
            .then(response => response.json())
            .then(data => {
                // Sort by ID descending and take top 3
                const sortedData = [...data].sort((a, b) => b.id - a.id).slice(0, 3);
                setActivitiesData(sortedData);
            })
            .catch(error => console.error('Error fetching activities data:', error));
    }, []);


    return (
        <div className="mainArea transition-effect" id="activities">
            <div className="activities transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Activities Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Activities
                            </div>
                        </div>
                        <div className="rightContent">
                            {activitiesData.map((activity, index) => (
                                <div className="activityItem" key={index}>
                                    <p className="activityTitle">
                                        {activity.title}
                                        <span className="activityPeriod">{activity.period}</span>
                                    </p>
                                    <p className="activityDesc">
                                        {activity.description}
                                    </p>
                                </div>
                            ))}

                            <div className="activityViewMoreContainer">
                                <Link to="/activities" className="activityViewMoreLink">
                                    View More <i className="fa-solid fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Activities Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Activities;
